export default {
    brand: {
      "active" : true,
      "brandId" : "ad2afdc0-2e3d-9b4a-2f3d-b1ad0319866f",
      "brandName" : "NutriBullet",
      "brandSlug" : "nutribullet",
      "cartLink" : "https://www.nutriliving.com/cart",
      "cartName" : "Capital Brands",
      "cartPlatform" : "nutribullet",
      "cartSupport" : true,
      "category" : "consumer products and goods",
      "created_at" : "Wed Jul 12 2017 11:05:03 GMT-0400 (EDT)",
      "created_by" : "jordan@mikmak.tv",
      "modified_at" : "Tue Aug 22 2017 16:58:07 GMT-0400 (EDT)",
      "modified_by" : "maggie@mikmak.tv",
      "utmParameters" : ""
    },
    products: [
      {
        "cartMetadata" : {
          "addToCartUrl" : "https://www.nutriliving.com/cart/add/nl_mb/1",
          "hiddenInputs" : []
        },
        "category" : "kitchen",
        "description" : "<br>Grate, grind, blend, chop and mix with one machine! <br> In just seconds, you can make: <br> &middot; Salsas <br> &middot; Pasta sauces <br> &middot; Frosty milkshakes <br> &middot; And more!",
        "id" : 0,
        "name" : "Magic Bullet",
        "price" : "39.99",
        "product-images" : [ "//cartassets.imgix.net/img/636/nl_mb.jpg" ],
        "productUrl" : "https://www.nutriliving.com/shop/magic-bullet",
        "slug" : "magic-bullet"
      }
    ]
  }



// WEBPACK FOOTER //
// ./client/store/products/nutribullet.js